// Marketing attribution helpers for Meta CompleteRegistration tracking.
// Load on landing so CTAs can carry UTMs/fbclid across to the signup app.

const ATTR_KEY = 'bizflex_marketing_attribution_v1';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const ATTR_FIELDS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'campaign_id',
  'adset_id',
  'ad_id',
  'placement',
  'fbclid',
];

const ALLOWED_SIGNUP_HOSTS = new Set([
  'bizflex.com.ng',
  'www.bizflex.com.ng',
  'bizflex.africa',
  'www.bizflex.africa',
  'app.bizflex.africa',
  'localhost',
]);

export function readAttribution() {
  try {
    const a = JSON.parse(localStorage.getItem(ATTR_KEY) || 'null');
    if (a && Number.isFinite(a.saved_at) && Date.now() - a.saved_at < TTL_MS) {
      return a;
    }
    localStorage.removeItem(ATTR_KEY);
  } catch {
    // Storage can be blocked; CTAs must still work.
  }
  return null;
}

export function captureAttribution(marketingAllowed = true) {
  if (!marketingAllowed) return null;
  const q = new URLSearchParams(window.location.search);
  const incoming = {};
  for (const k of ATTR_FIELDS) {
    const v = q.get(k);
    if (v && v.length <= 1000) incoming[k] = v;
  }
  if (!Object.keys(incoming).length) return readAttribution();
  const a = { ...incoming, saved_at: Date.now() };
  try {
    localStorage.setItem(ATTR_KEY, JSON.stringify(a));
  } catch {
    // ignore
  }
  return a;
}

/**
 * Append stored attribution params onto an allowed outbound signup/login URL.
 * Preserves any existing query params on the destination (e.g. from=glovo).
 */
export function attributedSignupUrl(rawUrl, marketingAllowed = true) {
  try {
    const u = new URL(rawUrl, window.location.origin);
    if (
      (u.protocol !== 'https:' &&
        !(u.protocol === 'http:' && u.hostname === 'localhost')) ||
      !ALLOWED_SIGNUP_HOSTS.has(u.hostname)
    ) {
      return rawUrl;
    }
    if (!marketingAllowed) return u.href;
    const a = readAttribution();
    if (a) {
      for (const k of ATTR_FIELDS) {
        if (a[k]) u.searchParams.set(k, a[k]);
      }
    }
    return u.href;
  } catch {
    return rawUrl;
  }
}

/** Capture current page params, then return an attributed outbound URL. */
export function getAttributedAppUrl(rawUrl, marketingAllowed = true) {
  if (typeof window === 'undefined') return rawUrl;
  captureAttribution(marketingAllowed);
  return attributedSignupUrl(rawUrl, marketingAllowed);
}
